<div class="phone-number-info">
  <div class="summary-header">
    {{ phoneNumberValue | formatPhoneNumbers }}{{ displayName ? ' - ' + displayName : '' }}
  </div>
  @if (phoneNumber.providerId) {
    <div>
      <h5>Provider</h5>
      <div class="phone-number-info-item">{{ phoneNumber.providerId }}</div>
    </div>
  }
  @if (phoneNumber.isPorted && phoneNumber.datePorted) {
    <div>
      <h5>Port Information</h5>
      <div class="phone-number-info-item"> Ported on {{ phoneNumber.datePorted | date : 'MM/dd/yyyy hh:mm aa' }} </div>
    </div>
  }
  @if (phoneNumber.routeTo) {
    <div>
      <h5>Routing To:</h5>
      <div class="phone-number-info-item">
        {{ phoneNumber.routeTo.number }}{{ phoneNumber.routeTo.name ? ' - ' + phoneNumber.routeTo.name : '' }}
      </div>
    </div>
  }
</div>
